const groupTitles = new Map<string, string>([
  ['businessInfo', 'BusinessDetails'],
  ['finance', 'BusinessFinancialDetails'],
  ['businessOwner', 'BusinessOwner'],
  ['coOwnerInfo', 'BusinessCoOwners'],
  ['bank', 'BankDetails'],
  ['review', 'Review.SectionTitle'],
])

export const getGroupTitle = (groupName: string) => {
  return groupTitles.get(groupName) || ''
}
